
import { useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import "../../newstyle.css";
import { Link, useNavigate } from "react-router-dom";
import SearchBox from "../../../../Components/SearchBox";
import { Formik } from "formik";
import { DiscoverSearchBarInitialValues } from "../../constant";
import { useQuery } from "@tanstack/react-query";
import { useMutateDeleteDiscover } from "../../hooks/useApiHook";
import {
  Confirmation,
  ErrorToast,
  SuccessToast,
} from "../../../../Utils/SweetAlert";
import Pagination from "../../../../Utils";
import { IoEye } from "react-icons/io5";
import { GetDiscoverList } from "../../../../Api/discover";
import NameInitial from "../../../../Components/NameInitial/Nameinitial";
import { EditButton, DeleteButton, CustomConfirmation } from "../../../../Components";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import AddButton from "../../../../Components/AddButton";
import PhaseSelect from "../../../../Components/PhaseSelect";

const DiscoverListing = () => {
  /**
 //    * States
 //    */
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [selectedPhase, setSelectedPhase] = useState(
    DiscoverSearchBarInitialValues.phase || ""
  );

  const formRef = useRef();
  const navigate = useNavigate();

  //   /**
  //    * Api
  //    */
  const deleteDiscover = useMutateDeleteDiscover();

  //   /**
  //    * Get discover pagination data
  //    */
  const {
    isFetching: discoverDataLoading,
    data: discoverData,
    refetch,
  } = useQuery({
    queryKey: ["get-discover-list", limit, page, selectedPhase],
    queryFn: () =>
      GetDiscoverList({
        page: page === 0 ? 1 : page + 1,
        limit: limit,
        search: formRef?.current?.values?.search,
        phase: selectedPhase || "",
      }),
    throwOnError: (error) => {
      ErrorToast(error?.response?.data?.message || "Server Error.");

    },
  });

  //   /**
  //    * Used to change page
  //    * @param {number} e "Page change event"
  //    * @param {number} pageNew "New page number"
  //    */
  const handlePageChange = async (e, pageNew) => {
    setPage(pageNew);
    refetch();
  };

  //   /**
  //    * Used to change limit
  //    * @param {any} event "Limit change event"
  //    */
  const handleLimitChange = async (event) => {
    setPage(0);
    setLimit(parseInt(event.target.value, 10));
    refetch();
  };

  //   /**
  //    * Used to delete discover record
  //    * @param {number} discoverId "Discover id"
  //    */

  return (
    <>
      <Helmet>
        <title>OVE | Admin Discover</title>
      </Helmet>
      <div className="page-wrapper admin-user">
        <div className="content container-fluid">
          <div className="admin-wrapper">
            <div className="page-header">
              <div className="col">
                <h1 className="page-title">Discover</h1>
              </div>
              <div className="col-12 col-md-3 col-lg-4 px-2">
                <Formik
                  initialValues={DiscoverSearchBarInitialValues}
                  innerRef={formRef}
                >
                  {({ values, setFieldValue }) => {
                    const filterStyles = {
                      option: (styles, { isDisabled }) => ({
                        ...styles,
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        marginTop: "0px",
                        marginBottom: "0px",
                      }),
                      control: (styles, state) => ({
                        ...styles,
                        border: "2px solid #00000061",
                        borderColor: state.isFocused ? "#AD5ADC" : "#F7F5F5",
                        boxShadow: state.isFocused ? "0 0 0 1px #AD5ADC" : "none",
                        borderRadius: "20px",
                        minHeight: 42,
                        height: 42,
                        paddingLeft: 6,
                      }),
                      valueContainer: (styles) => ({
                        ...styles,
                        paddingTop: 0,
                        paddingBottom: 0,
                        height: 38,
                      }),
                      input: (styles) => ({
                        ...styles,
                        margin: 0,
                        padding: 0,
                      }),
                      placeholder: (styles) => ({
                        ...styles,
                        color: "#6b6b6b",
                      }),
                      singleValue: (styles) => ({
                        ...styles,
                        color: "#000",
                        fontWeight: 400,
                      }),
                      menu: (styles) => ({
                        ...styles,
                        borderRadius: "20px",
                        overflow: "hidden",
                        cursor: "pointer",
                      }),
                    };
                    return (
                      <div className="d-flex gap-2">
                        <div className="w-100">
                          <PhaseSelect
                            value={values.phase}
                            includeAllOption
                            placeholder="Filter Phase"
                            onChange={(phase) => {
                              const normalizedPhase = phase || "";
                              setFieldValue("phase", normalizedPhase);
                              setSelectedPhase(normalizedPhase);
                              setPage(0);
                            }}
                            isClearable={false}
                            selectStyles={filterStyles}
                          />
                        </div>
                        <div className="w-100">
                          <SearchBox refetch={refetch} setPage={setPage} />
                        </div>
                      </div>
                    );
                  }}
                </Formik>
              </div>
              <div>
                <AddButton
                  to="/admin/add-discover"
                  permission="create-discover"
                />
              </div>
            </div>
            <div className="col-sm-12 table-width">
              <div className="cards-table card-table">
                <div className="card-body">
                  <div className="table-responsive discover-table custom-pagination table-no-padding">
                    <table className="table datatable table-manager">
                      <thead className="thead-light">
                        <tr>
                          <th>Icon</th>
                          <th>Name</th>
                          <th>Title</th>
                          <th>Phase</th>
                          <th>Subscription</th>
                          <th className="text-center col-action">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {discoverDataLoading && (
                          <tr>
                            <td align="center" colSpan={6}>
                              <div className="d-flex justify-content-center align-items-center py-4">
                                <div className="spinner-border loader-theme" role="status" />
                              </div>
                            </td>
                          </tr>
                        )}
                        {!discoverDataLoading && discoverData !== undefined && (
                          <>
                            {discoverData?.data?.data.map((item, index) => {
                              return (
                                <tr key={index} className="table disable-row">
                                  <td>
                                    {item?.icon_url && item?.icon_url.trim() !== "" ? (
                                      <img
                                        src={item?.icon_url}
                                        alt="img"
                                        className="list-image-news"
                                      />
                                    ) : (
                                      <NameInitial
                                        name={item.name}
                                        type="image"
                                      />
                                    )}
                                  </td>
                                  <td>
                                    <Tooltip title={item.name} placement="top">
                                      <span>
                                        {item.name?.length >= 45
                                          ? item.name.substring(0, 40) + "..."
                                          : item.name || "-"}
                                      </span>
                                    </Tooltip>
                                  </td>
                                  <td>
                                    <Tooltip title={item.title} placement="top">
                                      <span>
                                        {item.title?.length >= 45
                                          ? item.title.substring(0, 40) + "..."
                                          : item.title || "-"}
                                      </span>
                                    </Tooltip>
                                  </td>
                                  <td className="col-phase text-start">
                                    <span className="category-cell-ellipsis">
                                      {(item?.phase || "-")
                                        .replace(/_/g, " ")
                                        .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())}
                                    </span>
                                  </td>
                                  <td className={item?.subscriptionType ? "text-start" : "text-center"}>
                                    <span className="category-cell-ellipsis">
                                      {(item?.subscriptionType || "-")
                                        .replace(/_/g, " ")
                                        .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())}
                                    </span>
                                  </td>

                                  <td className="category-td-padding-remove col-action text-center main-action-button">
                                    <EditButton
                                      to="/admin/edit-discover"
                                      state={{ id: item?._id }}
                                      permission="edit-discover"
                                    />
                                    <DeleteButton
                                      onDelete={() => {
                                        Confirmation("Are you sure you want to delete discover?").then((result) => {
                                          if (result.isConfirmed) {
                                            const reqData = { id: item?._id };
                                            deleteDiscover.mutate(reqData, {
                                              onSuccess: (response) => {
                                                if (response?.status != 0) {
                                                  SuccessToast(response?.message || "Delete Successful.");
                                                  refetch();
                                                } else {
                                                  ErrorToast(response?.message || "Server Error.");
                                                }
                                              },
                                              onError: (error) => {
                                                ErrorToast(error?.response?.data?.message || "Server Error.");
                                              },
                                            });
                                          }
                                        });
                                      }}
                                      permission="delete-discover"
                                    />
                                    <Tooltip
                                      title="View"
                                      className="btn btn-sm btn-white text-success insight-stickey-actions-btn"
                                      onClick={() =>
                                        navigate("/admin/discover-detail", {
                                          state: { id: item?._id },
                                        })
                                      }
                                    >
                                      <IconButton>
                                        <IoEye
                                          // size="34"
                                          className="text-secondary icon-color p-0"
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </td>
                                </tr>
                              );
                            })}
                            {discoverData?.data?.data?.length === 0 && (
                              <tr>
                                <td className="text-center" colSpan={6}>
                                  No Records Found.
                                </td>
                              </tr>
                            )}
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <Pagination
              totalItem={discoverData?.data?.totalRecords || 0}
              itemsPerPage={limit}
              page={
                !discoverData?.data?.totalRecords ||
                  discoverData?.data?.totalRecords <= 0
                  ? 0
                  : page
              }
              handleChangePage={handlePageChange}
              handleChangeRowsPerPage={handleLimitChange}
              colSpan={7}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default DiscoverListing;
